import axios from 'axios';
import ServerProperties from '../../config/server.js'

export default {
  PingToServer: function(params) {
    axios.defaults.headers.common['Authorization'] = null;
    axios.get(ServerProperties.ATM_CLOUD.API + "system/ping/")
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {            
      params.onfailed(error)
      console.log(error);
    });
  }
}


// WEBPACK FOOTER //
// ./src/App/system/ping/model.js